<template>
  <el-row>
    <el-row class="sj-container">
      <el-table :highlight-current-row="true"
                :data="table"
                :show-header="false"
                border>
        <el-table-column width="150"
                         prop="label">
          <template slot-scope="scope">
            <b>{{scope.row.label}}</b>
          </template>
        </el-table-column>
        <el-table-column min-width="150">
          <template slot-scope="scope">
            <span v-if="detailData[scope.row.key] || detailData[scope.row.key] === 0 ">
              <span v-if="detailData[scope.row.key].constructor === String">{{detailData[scope.row.key]}}</span>
              <span v-if="ifKey(scope, 'userid') || ifKey(scope, 'posts') || ifKey(scope, 'comments')">
                {{detailData[scope.row.key]}}
              </span>
              <span
                v-if="ifKey(scope, 'currentstatus') || ifKey(scope, 'level') || ifKey(scope, 'type') || ifKey(scope, 'believable') || ifKey(scope, 'is_forbidden_withdraw')">
                <span v-for="value in userOptions[scope.row.key]">
                  <span v-if="value.id === detailData[scope.row.key]">{{value.keyword}}</span>
                </span>
              </span>
              <span v-if="ifKey(scope, 'status')">
                <span v-for="value in freezeOptions">
                  <span v-if="value.id === detailData[scope.row.key]">{{value.keyword}}</span>
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            <span v-if="ifKey(scope, 'freeze_reason')">
                <span v-if="detailData[scope.row.key] === 99">{{ detailData['freeze_reason_customize'] }}</span>
                <template v-else>
                  <span v-for="value in userOptions[scope.row.key]">
                    <span style="color:rgb(88,157,248)"
                          v-if="value.id === detailData[scope.row.key]">{{value.keyword}}</span>
                  </span>
                </template>
              </span>
            <span
              v-if="ifKey(scope, 'tag') || ifKey(scope, 'label_tag') ||  ifKey(scope, 'teke_tag') || ifKey(scope, 'ability_group') || ifKey(scope, 'other_tag')">
                <span v-for="value in detailData[scope.row.key]">
                  <el-tag>{{value}}</el-tag>&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </span>
            <span v-if="ifKey(scope, 'occupations')">
              <span v-for="value in detailData.occupations">
                <el-tag>{{value.name}}</el-tag>&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </span>
            <span v-if="ifKey(scope, 'weixin_info') && detailData.weixin_info">
              {{detailData.weixin_info.nickname}}
            </span>
            <span v-if="ifKey(scope, 'workcard_photo')" style="display:flex; flex-wrap:wrap;">
              <template v-for="(url, index) in detailData.workcard_photo">
              <video v-if="isVideoFile(url)"
                     :key="'video-' + index"
                     :src="url"
                     preload="metadata"
                     style="width: 100px; height: 100px; object-fit: cover; margin-right: 8px; flex-shrink: 0; position: relative; cursor: pointer; background-color: #a9a5a5ff;"
                     @click="onPreviewVideo(url)">
                </video>
                <el-image v-else
                          :key="'img-' + index"
                          :src="url"
                          style="width: 100px; height: 100px; object-fit: cover; margin-right: 8px; flex-shrink: 0;"
                          :preview-src-list="detailData.workcard_photo.filter(u => !isVideoFile(u))">
                </el-image>
              </template>
            </span>
            <span v-if="ifKey(scope, 'workinfo_status')">
              <template v-for="item in options.workinfoStatus"
                        v-if="parseInt(item.value) === parseInt(detailData.workinfo_status)">
                <span>{{item.label}}</span>
              </template>
            </span>
            <span v-if="ifKey(scope, 'current_location')">
                <div>{{getValue(scope,'user')}} &nbsp;&nbsp;&nbsp;&nbsp;(心跳)</div>
                <div>{{getValue(scope,'system')}} &nbsp;&nbsp;&nbsp;&nbsp;(工单)</div>
              </span>
            <span v-if="ifKey(scope, 'current_market_system')">
              <div>{{ detailData.current_market.system }}</div>
            </span>
            <span v-if="ifKey(scope, 'user_watched_market')">
              {{ detailData.user_watched_market.map(m => m.marketname + '/' + m.id).join('， ') }}
            </span>
            <span v-if="ifKey(scope, 'user_watched_locations')">
              <template v-for="location in detailData.user_watched_locations">
                <div>{{location.location_name}}：{{location.location_address}}，周边{{location.distance}} km</div>
              </template>
            </span>
            <span v-if="ifKey(scope, 'order_list')">
                 <router-link style="text-decoration:none" :to="'/order/table?userid='+id" target="_blank">
                    <span style="color: rgb(88,157,248);">订单列表</span>
                  </router-link>&nbsp;&nbsp;&nbsp;&nbsp;

                <router-link style="text-decoration:none"
                             :to="{path: '/users/amount?userid='+id}">
                  <span style="color:rgb(88,157,248);">赏金明细</span>
                </router-link>&nbsp;&nbsp;&nbsp;&nbsp;
                <router-link style="text-decoration:none"
                             :to="{path: '/users/point?userid='+id}">
                  <span style="color:rgb(88,157,248);">积分明细</span>
                </router-link>

              </span>
            <span v-if="ifKey(scope, 'archieve_tasks_list')">
                <a :href="base+'/index.php?action=es_task&isoffline=1&userid='+detailData['userid']"
                   target="_blank"
                   style="text-decoration:none">
                  <span style="color:rgb(88,157,248);">归档任务列表页</span>
                </a>
              </span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- 视频预览弹窗（复用功能更完整的 VideoPlayerDialog 组件） -->
    <video-player-dialog
      :visible.sync="videoPreviewVisible"
      :videos="videoPreviewVideos"
      :index="videoPreviewIndex" />
  </el-row>
</template>

<script>
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'
import VideoPlayerDialog from '@views/user-workinfo/components/VideoPlayerDialog.vue'

export default {
  mixins: [userWorkInfoMixin],
  components: {VideoPlayerDialog},
  data () {
    return {
      id: this.$route.query.userid || 0,
      base: window._env_.VUE_APP_OLD_ADMIN_HOST,
      detailData: {
        userid: null,
        currentstatus: null,
        status: null,
        freeze_reason: null,
        freeze_reason_customize: null,
        cellphone: null,
        weixin_info: null,
        nickname: null,
        realname: null,
        tag: null,
        label_tag: null,
        teke_tag: null,
        other_tag: null,
        ability_group: null,
        level: null,
        IDcard_location: null,
        idcard_address: null,
        idcard_expired_date: null,
        idcard_expire_status_str: null,
        current_location: [],
        current_market: [],
        user_watched_market: [],
        user_watched_locations: [],
        referrercode: null,
        order_list: 3,
        archieve_tasks_list: 1,
        registertime: null,
        referrer: null,
        is_forbidden_withdraw: 0,
        believable: null,
        type: null,
        occupations: [],
        workcard_photo: [],
        workinfo_status: 0,
        belongto: '',
        business_type: 0,
        business_type_txt: '',
        work_type: 0,
        work_type_txt: '',
        know_from: '',
        last_active_tp: null,
        str_register_app_type: '',
        str_last_active_app_type: '',
      },
      freezeOptions: [
        {id: 0, keyword: '待验证'},
        {id: 1, keyword: '已验证'},
        {id: -1, keyword: '阶段性封号'},
        {id: -2, keyword: '永久性封号'},
      ],
      table: [
        {
          key: 'userid',
          label: '用户ID',
        },
        {
          key: 'currentstatus',
          label: '当前状态',
        },
        {
          key: 'type',
          label: '用户类型',
        },
        {
          key: 'status',
          label: '用户状态',
        },
        {
          key: 'freeze_reason',
          label: '封号原因',
        },
        {
          key: 'is_forbidden_withdraw',
          label: '禁止提现',
        },
        {
          key: 'believable',
          label: '是否可信',
        },
        {
          key: 'cellphone',
          label: '手机号码',
        },
        {
          key: 'weixin_info',
          label: '当前绑定微信',
        },
        {
          key: 'nickname',
          label: '昵称',
        },
        {
          key: 'realname',
          label: '用户名称',
        },
        {
          key: 'tag',
          label: '主平台标签',
        },
        {
          key: 'occupations',
          label: '自选职业',
        },
        {
          key: 'business_type_txt',
          label: '行业',
        },
        {
          key: 'work_type_txt',
          label: '工种',
        },
        {
          key: 'belongto',
          label: '厂家',
        },
        {
          key: 'workcard_photo',
          label: '工作证',
        },
        {
          key: 'workinfo_status',
          label: '职业信息状态',
        },
        {
          key: 'label_tag',
          label: '标注标签',
        },
        {
          key: 'teke_tag',
          label: 'teke标签',
        },
        {
          key: 'other_tag',
          label: '其他标签',
        },
        {
          key: 'ability_group',
          label: '用户能力组',
        },
        {
          key: 'level',
          label: '用户等级',
        },
        {
          key: 'idcard_expired_date',
          label: '身份证过期时间',
        },
        {
          key: 'idcard_expire_status_str',
          label: '实名信息有效状态',
        },
        {
          key: 'idcard_address',
          label: '身份证详细地址',
        },
        {
          key: 'IDcard_location',
          label: '身份证所在地',
        },
        {
          key: 'current_location',
          label: '当前所在地',
        },
        { key: 'current_market_system', label: '最后做单门店' },
        { key: 'user_watched_market', label: '关注门店' },
        { key: 'user_watched_locations', label: '关注区域' },
        {
          key: 'referrercode',
          label: '推荐码',
        },
        {
          key: 'referrer',
          label: '推荐人手机',
        },
        {
          key: 'know_from',
          label: '了解途径',
        },
        {
          key: 'registertime',
          label: '注册时间',
        },
        {
          key: 'str_register_app_type',
          label: '注册平台',
        },
        {
          key: 'last_active_tp',
          label: '最后登录时间',
        },
        {
          key: 'str_last_active_app_type',
          label: '最后登录平台',
        },
        {
          key: 'order_list',
          label: '订单列表',
        },
        {
          key: 'archieve_tasks_list',
          label: '归档任务列表',
        },
      ],
      attach_file_visible: false,
      videoPreviewVisible: false,
      videoPreviewVideos: [],
      videoPreviewIndex: 0,
    }
  },
  computed: Vuex.mapState({
    userOptions: state => state.users.userOptions,
    options: state => state.users.options,
  }),
  async created () {
    if (this.id) {
      await this.setFormData(this.id)
    }
  },
  mounted () { },
  methods: {
    ...Vuex.mapActions([]),

    ifKey (scope, name) {
      return scope.row.key === name
    },
    setFormData (id) {
      request.page('getUserDetail', id).then(async ({data}) => {
        for (const key in data) {
          if (this.detailData.hasOwnProperty(key)) {
            // 默认获得来源数据
            let value = data[key]
            if (key === 'tag') {
              this.setTagDetail(value)
              continue
            }

            this.detailData[key] = value
          }
        }
        this.detailData.workinfo_status = parseInt(this.detailData.workinfo_status)

        await request.common('getUserLatestWorkInfoApi', {userid: id}).then(({data}) => {
          this.detailData.workcard_photo = _.get(data, 'workcard_photo', this.detailData.workcard_photo)
          this.detailData.belongto = _.get(data, 'belongto', this.detailData.belongto)
          this.detailData.work_type_txt = _.get(data, 'work_type_txt', this.detailData.work_type_txt)
          this.detailData.business_type = _.get(data, 'business_type', this.detailData.business_type)
        })
        this.detailData.workcard_photo = this.detailData.workcard_photo.map((item) => {
          return this.isVideoFile(item) ? item : filter.ossFormatJpg(item)
        })

        const businessTypeObj = this.userOptions.business_type.find(it => it.id + '' === this.detailData.business_type + '')
        this.detailData.business_type_txt = _.get(businessTypeObj, 'title', '')
      })
    },
    setTagDetail (source) {
      let tag = []
      let labelTag = []
      let otherTag = []
      let tagFirstLetter = ''
      for (let i = 0; i < source.length; i++) {
        tagFirstLetter = source[i].substr(0, 1)
        if (tagFirstLetter === 'A') {
          tag.push(source[i])
        } else if (tagFirstLetter === 'B') {
          labelTag.push(source[i])
        } else {
          otherTag.push(source[i])
        }
      }
      this.detailData.tag = tag
      this.detailData.label_tag = labelTag
      this.detailData.other_tag = otherTag
    },
    getValue (scope, name) {
      return this.detailData[scope.row.key][name]
    },
    filterImgUrl (url) {
      let suffix = ''
      if (url.indexOf('?x-oss-process') === -1) {
        suffix = '?x-oss-process=image/resize,w_200/auto-orient,1'
      }
      return filter.ossHost(url, suffix)
    },
    onPreviewVideo (url) {
      // 构造所有视频 URL 列表，并计算当前点击视频的索引，交给 VideoPlayerDialog 播放
      const videoList = (this.detailData.workcard_photo || []).filter(photo => this.isVideoFile(photo))
      this.videoPreviewVideos = videoList
      this.videoPreviewIndex = Math.max(videoList.indexOf(url), 0)
      this.videoPreviewVisible = true
    },
  },
}
</script>
</style>



// WEBPACK FOOTER //
// src/views/users/pages/detail/UsersDetail.vue